import { BaseModel } from './base-model';
import { Markup } from './markup';

export class Attachment extends BaseModel {

  /* tslint:disable */
  mime: string;
  original_name: string;
  original_url: string;
  size: number;
  thumb_url: string;
  preview_url: string;
  fileType?: string;
  width?: number;
  height?: number;
  markups: Markup[];
  // Photo proof (GeoStamp, mobile 7.3): the record the phone built at the shutter,
  // the server's hash of the stored bytes, and the stamped copy when one was burned.
  proof?: any;
  captured_at?: string;
  accuracy_m?: number | string;
  capture_source?: 'camera' | 'library' | null;
  stamped_url?: string | null;
  sha256?: string | null;
  /** The row's created_at, kept because parseJSONData drops created_at: "Received by server". */
  received_at?: string;

  // for CASL subject detection on code minification
  static get modelName() {
    return 'Attachment';
  }

  /* tslint:enable */

  get relations() {
    return {
      markups: Markup,
    };
  }

  get isImage() {
    if (this.mime === 'image/heif') {
      return false;
    }
    return /^image/.test(this.mime);
  }

  get isLandscape(): boolean {
    return this.width && this.height ? this.width > this.height : false;
  }

  get isPortrait(): boolean {
    return this.width && this.height ? this.height > this.width : false;
  }

  get isSquare(): boolean {
    return this.width && this.height ? this.width === this.height : false;
  }

  get orientation(): 'landscape' | 'portrait' | 'square' | null {
    if (!this.width || !this.height) return null;
    if (this.width > this.height) return 'landscape';
    if (this.height > this.width) return 'portrait';
    return 'square';
  }

  get preview() {
    if (this.isImage) {
      return this.preview_url || this.thumb_url || this.original_url;
    }

    if (this.thumb_url || this.preview_url) {
      return this.preview_url || this.thumb_url;
    }

    let icon = '/assets/icons/file.png';
    switch (this.mime) {
      case 'application/pdf':
        icon = '/assets/icons/pdf.png';
        break;
      // case 'text/csv': icon = '/assets/icons/csv.png'; break;
    }
    return icon;
  }

  /**
   * Processes json obj and sets respective properties.
   * @param jsonObj json from api
   */
  parseJSONData(jsonObj: any) {
    super.parseJSONData(jsonObj);

    // The server receipt time backs the proof's "Received by server" row.
    if (jsonObj?.created_at && !this.received_at) {
      this.received_at = jsonObj.created_at;
    }

    // cast
    delete this.created_at;
    delete this.updated_at;
  }

  getThumbnail() {
    const defaultImg = '/assets/default.jpg';
    return this.thumb_url || (/^image/.test(this.mime) ? this.original_url : defaultImg);
  }
}
